module.exports = __webpack_public_path__ + "img/product-banner1.784a739f.jpg";